import {PixiSpineResource} from "./resources/pixi-spine-resource";
import {PixiAnimationAbstract} from "./pixi-animation.abstract";
import {PixiAsset} from "./pixi-assets-manager/asset/pixi-asset";
import {Application} from "./pixi-app.service.interface";
import {IPixiLibWrapper} from "./pixi-lib-wrapper/pixi-lib-wrapper.interface";

export class PixiSpineAnimation<T extends string = string> extends PixiAnimationAbstract<T, PixiSpineResource> {
    async onAssetsLoaded(loaderAssets: Record<T, PixiAsset>, pixiLibWrapper: IPixiLibWrapper) {
        const aliases = Object.keys(loaderAssets);
        const spineAssets = {} as Record<T, PixiSpineResource>;
        for (const currentAlias of aliases) {
            spineAssets[currentAlias] = pixiLibWrapper.createPixiSpineResource(loaderAssets[currentAlias]);
        }
        return spineAssets;
    }

    protected onBeforeRender(pixiApp: Application<HTMLCanvasElement>, resources: Record<T, PixiSpineResource>, pixiLibWrapper: IPixiLibWrapper): void {
        const aliases = Object.keys(resources);
        for (const currentAlias of aliases) {
            pixiApp.stage.addChild(resources[currentAlias].spineAnimation);
        }
    }
}
